module.exports = __webpack_public_path__ + "static/media/CMS-luckygames-detail.2da69b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/thumbs/CMS-luckygames-detail.png
// module id = 615
// module chunks = 0